import { SET_PAGE } from 'services/context/assessmentContext/assessmentContext';

export const setErrorPage = (response, dispatch) => {
  dispatch({
    type: SET_PAGE,
    payload: {
      assessment: null,
      assessmentIsLoading: false,
      assessmentError: {
        status: response ? response.status : '500',
        // A real response can still arrive without a JSON body (502/504 HTML
        // gateway pages), so this must not dereference data blindly.
        message: response?.data?.message || 'Something went wrong'
      }
    }
  });
};
